import React from "react";
import { useNavigate } from "react-router-dom";

const StylesForMale = ({ similarStyles }) => {
  const navigate = useNavigate();
  const handleClickScroll = () => {
    const element = document.getElementById("product");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="col-12 styles_for_male">
        <div>
          {similarStyles?.map((style, ids) => (
            <div>
              <img
                alt="img"
                onClick={() => {
                  handleClickScroll()
                  navigate("/tailoring/product", {
                    state: {
                      src: style.image_url,
                      id: 1,
                      stylename: style.name,
                      uniqueId: style._id,
                      description: style.desc,
                      price: style.price,
                    },
                  });
                }}
                src={style.image_url[0]}
              />
              <p className="styles_name">
                <span>{style.name}</span>
                <span>₦{style.price}</span>
              </p>
            </div>
          ))}
          {/* <div>
            <img
              alt="img"
              onClick={() =>
                navigate("/tailoring/product", {
                  state: {
                    src: FifthStyle,
                    id: 1,
                    stylename: "Two Piece African Print",
                    price: "166076.00",
                    uniqueId: 10,
                    description: "African Prints",
                  },
                })
              }
              src={FifthStyle}
            />
            <p className="styles_name">
              <span>Two Piece African Print </span>
              <span>₦166,076.00</span>
            </p>
          </div>
          <div>
            <img
              alt="img"
              onClick={() =>
                navigate("/tailoring/product", {
                  state: {
                    src: SixthStyle,
                    id: 1,
                    stylename: "Two Piece Senator",
                    price: "166076.00",
                    uniqueId: 11,
                    description: "African Prints",
                  },
                })
              }
              src={SixthStyle}
            />
            <p className="styles_name">
              <span>Two Piece Senator</span>
              <span>₦166,076.00</span>
            </p>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default StylesForMale;
